"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
var Chevron = function (props) {
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ onClick: props === null || props === void 0 ? void 0 : props.onClick, className: props.className, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M12 16L4 8.4052L5.48673 7L12 13.1561L18.5133 7L20 8.4052L12 16Z", fill: "currentColor" }) })));
};
exports["default"] = Chevron;
//# sourceMappingURL=chevron.js.map